import React, { useState } from 'react';
import Button from '../Button';
import CheckCircleIcon from '../CheckCircleIcon';
import Modal from '../Modal';

import useCopy from '../../util/useCopy';
import CurrentUserResource from '../../resources/Auth/CurrentUser';
import { HandleInput } from '../HandleInput';

const ChangeHandleModal = ({ isOpen, onClose, onSave }) => {
  const copy = useCopy();
  const [currentUser] = CurrentUserResource.useLoadable();
  const [handleState, setHandleState] = useState({ value: '', isValid: false });

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="ChangeHandleModal">
      <Modal.MainText>
        <p>{copy.enterANewUniqueScreenNameBelow}</p>
      </Modal.MainText>
      <Modal.BottomActions>
        <HandleInput
          currentHandle={currentUser.handle || ''}
          onChange={setHandleState}
        />
        <Button
          stacked
          disabled={!handleState.isValid}
          onClick={() => {
            onSave(handleState.value);
          }}
          Icon={CheckCircleIcon}
        >
          {copy.save}
        </Button>
      </Modal.BottomActions>
    </Modal>
  );
};

export default ChangeHandleModal;
